import FJAppConstant from '../../constants/FJAppConstant';
import { RELEASE } from '../../constants/FJEvnConstant';

const environment = import.meta.env.MODE;

const FJAIPhotoEditorConfig = {
    resultImageKey: 'ai/export/photo-editor/',
    originalImageKey: 'ai/input/photo-editor/',
    historyListType: 36, // 使用一个新的唯一类型
    appType: FJAppConstant.AI_PHOTO_EDITOR,
    currentMenuName: 'ai-photo-editor',
    freeLimitType: 'ai-photo-editor',
    notImageBoxDesc: 'ai-photo-editor-description',
    notImageBoxTitle: 'ai-photo-editor-title',
    notImageBoxVideoUrl:
        environment === RELEASE
            ? `https://resource.flexclip.com/app/ai-tools/resource/ai-photo-editor/ai-photo-editor-demonstration.mp4`
            : `https://www.smartvideomaker.com/app/ai-tools/resource/ai-photo-editor/ai-photo-editor-demonstration.mp4`,
    presetCoverUrl:
        environment === RELEASE
            ? `https://resource.flexclip.com/app/ai-tools/resource/ai-photo-editor/cover/`
            : 'https://www.smartvideomaker.com/app/ai-tools/resource/ai-photo-editor/cover/',
    presetVideoUrl:
        environment === RELEASE
            ? `https://resource.flexclip.com/app/ai-tools/resource/ai-photo-editor/video/`
            : 'https://www.smartvideomaker.com/app/ai-tools/resource/ai-photo-editor/video/',
    modelIconPath:
        environment === RELEASE
            ? `https://resource.flexclip.com/app/ai-tools/img/`
            : `https://www.smartvideomaker.com/app/ai-tools/img/`,
};

export default FJAIPhotoEditorConfig;
